import * as actionTypes from "../actions/actionTypes";
import { combineReducers } from "redux";
import AnalyticsReducer from "./analyticsReducer";
import UserReducer from "./userReducer";
import ToolkitReducer from "./toolkitReducer";
import OfficeReducer from "./officeReducer";
import DaniReducer from "./daniReducer";
import ReportReducer from "./reportReducer";
import reportingReducer from "./reportingReducer";
import OrgChartReducer from "./orgChartReducer";
import mapGenderReducer from "./mapGenderReducer";
import mapPositionsReducer from "./mapPositionsReducer";
import mapPerformanceReducer from "./mapPerformanceReducer";
import mapVeteranReducer from "./mapVeteranReducer";
import mapSexualOrientationReducer from "./mapSexualOrientationReducer";
import mapReligionReducer from "./mapReligionReducer";
import mapDisabilityReducer from "./mapDisabilityReducer";
import mapEthnicityReducer from "./mapEthnicityReducer";
import kpiMasterReducer from "./kpiMasterReducer";
import mappingReducer from "./mappingReducer";
import mappingMasterReducer from "./mappingMasterReducer";
import enterpriseObjectiveReducer from "./enterpriseObjectiveReducer";
import adminDashboardReducer from "./AdminDashboardReducer";
import navBarReducer from "./navBarReducer";
import sortFilterParamsReducer from "./sortFilterParamsReducer";
import triviaReducer from "./triviaReducer";
import maturityModelReducer from "./maturityModelReducer";

const appReducer = combineReducers({
  user: UserReducer,
  analytics: AnalyticsReducer,
  toolkit: ToolkitReducer,
  office: OfficeReducer,
  dani: DaniReducer,
  reports: ReportReducer,
  orgChart: OrgChartReducer,
  mapGender: mapGenderReducer,
  mapPositions: mapPositionsReducer,
  mapPerformance: mapPerformanceReducer,
  mapVeteran: mapVeteranReducer,
  mapSexualOrientation: mapSexualOrientationReducer,
  mapReligion: mapReligionReducer,
  mapDisability: mapDisabilityReducer,
  mapEthnicity: mapEthnicityReducer,
  kpiMaster: kpiMasterReducer,
  mapping: mappingReducer,
  mappingMaster: mappingMasterReducer,
  enterpriseObjective: enterpriseObjectiveReducer,
  dashboard: adminDashboardReducer,
  navBar: navBarReducer,
  sortFilterParams: sortFilterParamsReducer,
  reporting: reportingReducer,
  trivia: triviaReducer,
  maturityModel:maturityModelReducer
  // item: itemReducer
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.LOGOUT) {
    // console.log('Logout', action);
    state = undefined;
    // localStorage.clear();
    // window.location.href = "";
    localStorage.removeItem("AutherizationToken")
  }
  return appReducer(state, action);
};

export default rootReducer;
